<div class="fill-height chamfer chart-container">


    <!-- <div echarts [options]="candleoptions" class="fill-height" *ngIf="candleoptions">
    </div> -->


    <div id="tv_chart_container"
    class="trading-view-container full-height"></div>
</div>